import React, { Component } from 'react';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  ListGroup,
  ListGroupItem,
  Nav,
  NavItem,
  NavLink,
  Row } from 'reactstrap';

const IconDocument = (props) => (
  <svg width="15px" height="20px" viewBox="0 0 15 20" fill="#B0ACBE" className={props.className}>
    <g stroke="none">
      <g transform="translate(-75.000000, -372.000000)">
        <g transform="translate(50.000000, 186.000000)">
          <g transform="translate(25.000000, 171.000000)">
            <path d="M8.75,20.3125 L8.75,15 L0.9375,15 C0.41796875,15 0,15.4179688 0,15.9375 L0,34.0625 C0,34.5820312 0.41796875,35 0.9375,35 L14.0625,35 C14.5820312,35 15,34.5820312 15,34.0625 L15,21.25 L9.6875,21.25 C9.171875,21.25 8.75,20.828125 8.75,20.3125 Z M15,19.7617188 L15,20 L10,20 L10,15 L10.2382812,15 C10.4882812,15 10.7265625,15.0976562 10.9023438,15.2734375 L14.7265625,19.1015625 C14.9023438,19.2773438 15,19.515625 15,19.7617188 Z" id="Shape"></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

class ConsumerDocuments extends Component {
  render() {
    return (
      <div className="page-documents pb-3">
        <Container fluid>
          <Row className="mb-3 align-items-center">
            <Col className="text-center text-md-left">
              <h3 className="mb-0">Documents</h3>
              <small><strong>Loan Nickname</strong> – 1234567</small>
            </Col>
            <Col xs={12} md="auto" className="text-right justify-content-end ml-md-3 mt-3 mt-md-0">
              <FormGroup className="dropdown-toggle mb-0 input-inline">
                <Input type="select" name="select" id="loanSelection" defaultValue="loan1">
                  <option value="">My Loans</option>
                  <option value="loan1">Loan ID – 1234567</option>
                  <option value="loan2">Loan ID – 2098773</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col>
              <Card>
                <Nav tabs>
                  <NavItem>
                    <NavLink className="active"><span>Your </span>Statements</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink><span>Loan </span>Agreements</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink>Other<span> Documents</span></NavLink>
                  </NavItem>
                </Nav>
                <h5 className="mx-3 mb-2 mt-2">2019 – Download Statements</h5>
                <ListGroup className="btn-list">
                  <ListGroupItem tag="a" href="/" className="d-flex align-items-center">
                    <IconDocument className="mr-1" /> Statement_September-12-2019.pdf
                  </ListGroupItem>
                  <ListGroupItem tag="a" href="/" className="d-flex align-items-center">
                    <IconDocument className="mr-1" /> Statement_August-12-2019.pdf
                  </ListGroupItem>
                  <ListGroupItem tag="a" href="/" className="d-flex align-items-center">
                    <IconDocument className="mr-1" /> Statement_July-12-2019.pdf
                  </ListGroupItem>
                  <ListGroupItem tag="a" href="/" className="d-flex align-items-center">
                    <IconDocument className="mr-1" /> Statement_June-12-2019.pdf
                  </ListGroupItem>
                  <ListGroupItem tag="a" href="/" className="d-flex align-items-center">
                    <IconDocument className="mr-1" /> Statement_May-12-2019.pdf
                  </ListGroupItem>
                  <ListGroupItem tag="a" href="/" className="d-flex align-items-center">
                    <IconDocument className="mr-1" /> Statement_April-12-2019.pdf
                  </ListGroupItem>
                  <ListGroupItem tag="a" href="/" className="d-flex align-items-center">
                    <IconDocument className="mr-1" /> Statement_March-12-2019.pdf
                  </ListGroupItem>
                  <ListGroupItem tag="a" href="/" className="d-flex align-items-center">
                    <IconDocument className="mr-1" /> Statement_February-12-2019.pdf
                  </ListGroupItem>
                  <ListGroupItem tag="a" href="/" className="d-flex align-items-center">
                    <IconDocument className="mr-1" /> Statement_January-12-2019.pdf
                  </ListGroupItem>
                </ListGroup>
                <CardBody>
                  <Button size="sm" color="white" className="d-flex align-items-center">
                    <img src="/icons/arrow-left-grey.svg" alt="Back" className="mr-1" />
                    2018
                  </Button>
                </CardBody>
              </Card>

            </Col>
          </Row>

        </Container>

      </div>
    );
  }
}

export default ConsumerDocuments;
